import { isEmpty } from 'bold-ui'
import { Form } from 'components/form'
import createDecorator from 'final-form-calculate'
import { MChatPerguntaEnum, MChatRiscoEnum } from 'graphql/types.generated'
import React, { MutableRefObject, useRef } from 'react'

import { consultaSeguimentoCalculator } from '../calculator-consultaSeguimento'
import { ConsultaSeguimentoModal } from '../consulta-seguimento-modal/ConsultaSeguimentoModal'
import { ConsultaSeguimentoFieldModel } from '../model-consultaSeguimento'
import { validatorConsultaSeguimento } from '../validator-consultaSeguimento'
import { initializeFirstPerguntaStatus } from './utils-consultaSeguimentoAplicacao'

interface ConsultaSeguimentoAplicacaoFormProps {
  aplicarButtonRef: React.RefObject<HTMLButtonElement>
  mChatPerguntasFalhas: MChatPerguntaEnum[]
  mChatRisco: MChatRiscoEnum
  valueInCache: ConsultaSeguimentoFieldModel
  onSubmit: (values: ConsultaSeguimentoFieldModel) => void
}

const decorator = createDecorator(...consultaSeguimentoCalculator)

export function ConsultaSeguimentoAplicacaoForm(props: Readonly<ConsultaSeguimentoAplicacaoFormProps>) {
  const { aplicarButtonRef, mChatPerguntasFalhas, mChatRisco, valueInCache, onSubmit } = props

  const hasValueInCache = !isEmpty(valueInCache)

  const initialValues: MutableRefObject<ConsultaSeguimentoFieldModel> = useRef({
    perguntasSelecionadas: hasValueInCache ? valueInCache.perguntasSelecionadas : mChatPerguntasFalhas,
    aplicacao: hasValueInCache ? initializeFirstPerguntaStatus(valueInCache.aplicacao) : null,
  })

  const renderForm = () => (
    <ConsultaSeguimentoModal
      valueInCache={valueInCache}
      mChatRisco={mChatRisco}
      mChatPerguntasFalhas={mChatPerguntasFalhas}
      aplicarButtonRef={aplicarButtonRef}
      onSave={onSubmit}
    />
  )

  return (
    <Form<ConsultaSeguimentoFieldModel>
      initialValues={initialValues.current}
      render={renderForm}
      validate={validatorConsultaSeguimento}
      decorators={[decorator]}
    />
  )
}
